module.exports = __webpack_public_path__ + "img/Inventory.de89f739.svg";